// extracted by mini-css-extract-plugin
module.exports = {"articlePageWrap":"article_articlePageWrap__1XwvR"};